'use client';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/overlay/dialog';
import { ArrowLeft } from '@phosphor-icons/react';
import { AlertTriangleIcon, CreditCardIcon } from '@/components/icons';
import { cn } from '@/lib/utils';

interface RouletteSetConflictDialogProps {
  open: boolean;
  onContinue: () => void;
  onBackToCart: () => void;
}

// Бэк отклоняет заказ «Сет дня» + приз рулетки (400 roulette_with_set_of_the_day)
// и ждёт повтор с confirmDropRoulette. Молча снимать приз нельзя — спрашиваем,
// как в приложении.
export function RouletteSetConflictDialog({
  open,
  onContinue,
  onBackToCart,
}: RouletteSetConflictDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onBackToCart();
      }}
    >
      <DialogContent showClose={false} className="max-w-md">
        <DialogHeader>
          <div className="flex items-start gap-3">
            <div className="w-11 h-11 rounded-card bg-[var(--warning-bg)] flex items-center justify-center flex-shrink-0">
              <AlertTriangleIcon weight="fill" className="w-6 h-6 text-[var(--warning)]" />
            </div>
            <div className="flex-1 pt-0.5">
              <DialogTitle>«Сет дня» не суммируется с рулеткой</DialogTitle>
              <DialogDescription className="mt-1">
                Оформить заказ без приза из рулетки? Сумма к оплате уменьшится на его цену.
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <DialogFooter className="mt-4">
          <button
            type="button"
            onClick={onBackToCart}
            className={cn(
              'inline-flex items-center justify-center gap-2 px-4 py-3 rounded-card text-sm font-medium',
              'bg-[var(--surface-secondary)] text-[var(--text-primary)]',
              'hover:bg-[var(--surface-tertiary)] transition-colors',
              'sm:flex-1'
            )}
          >
            <ArrowLeft weight="bold" className="w-4 h-4" />
            Вернуться в корзину
          </button>
          <button
            type="button"
            onClick={onContinue}
            className={cn(
              'inline-flex items-center justify-center gap-2 px-4 py-3 rounded-card text-sm font-medium sm:flex-1',
              'bg-[var(--primary)] text-[var(--text-inverse)]',
              'hover:opacity-90 transition-opacity'
            )}
          >
            <CreditCardIcon weight="fill" className="w-4 h-4" />
            Оформить без приза
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
